export default __webpack_public_path__ + "static/media/results_per_scale.5d764b8b.png";